<template>
    <div class="col-md-6 col-12">
        <h3 class="card-title ml-sm-4 mt-sm-2">Datos del abono</h3><br/><br/>
        <div class="mb-2">
            <b-list-group-item v-if="abonado.transacciones && abonado.transacciones.length > 0">
                <b>Método de pago: </b> <a>{{ abonado.transacciones[abonado.transacciones.length - 1].metodo_pago | formatear_metodo_pago }}</a>
            </b-list-group-item>
            <b-list-group-item v-if="abonado.observaciones">
                <b>Observaciones: </b> <a>{{ abonado.observaciones }}</a>
            </b-list-group-item>
            <b-list-group-item>
                <b>IBAN:</b> {{ abonado.iban }}
            </b-list-group-item>
            <b-list-group-item>
                <b>Titular de la cuenta:</b> {{ abonado.titular_cuenta }}
            </b-list-group-item>
            <b-list-group-item v-if="abonado.fecha_alta && !abonado.n_abonado_antiguo">
                <b>Fecha de alta: </b> <a>{{ abonado.fecha_alta }}</a>
            </b-list-group-item>
            <b-list-group-item v-if="abonado.fecha_antiguedad">
                <b>Fecha de antigüedad: </b> <a>{{ abonado.fecha_antiguedad }}</a>
            </b-list-group-item>
            <b-list-group-item>
                <b>Tipo de abono: </b>
                <a>
                    <template v-if="abonado.es_internacional">
                        Internacional
                    </template>
                    <template v-else>
                        <template v-if="abonado.precio != null">
                            {{ abonado.precio.descripcion }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </template>
                </a>
            </b-list-group-item>
            <b-list-group-item v-if="abonado.vendido_por && abonado.transacciones && abonado.transacciones.length > 0">
                <b>Vendido por: </b>
                <a v-if="abonado.transacciones[0].metodo_pago != 5">{{ abonado.vendido_por.name }} / {{ abonado.vendido_por.email }}</a>
                <a v-else>TPV Online</a>
            </b-list-group-item>
            <b-list-group-item v-if="abonado.origen">
                <b>Origen: </b> <a>{{ abonado.origen }}</a>
            </b-list-group-item>
            <b-list-group-item v-if="abonado.fecha_alta && abonado.n_abonado_antiguo">
                <b>Fecha de renovación: </b> <a>{{ abonado.fecha_alta }}</a>
            </b-list-group-item>
            <b-list-group-item v-if="abonado.footter">
                <b>Código: </b> <a>{{ abonado.footter }}</a>
            </b-list-group-item>
            <b-list-group-item>
                <b>Qr code: </b> <a>{{ abonado.qr_code }}</a>
            </b-list-group-item>
            <b-list-group-item>
                <b>Precio:</b>
                <a>
                    <template v-if="abonado.descuento != null">
                        {{ abonado.descuento.descripcion }} ({{ abonado.descuento.precio | formatear_precio }})
                    </template>
                    <template v-else>
                        -
                    </template>
                </a>
                <Button 
                    type="button" 
                    name="button" 
                    class="ml-0 ml-md-3 mt-2 mt-md-0" 
                    @click="$modal.show('cambiar-precio-' + abonado.id);"
                    v-if="abonado.transacciones && abonado.transacciones.length > 0 && abonado.transacciones[0].metodo_pago != 5 && ((abonado.plazos.length == 0 && !abonado.plazos_pagados) || (abonado.plazos.length > 0 && abonado.plazos_pagados))"
                >   
                    Cambiar tipo de abono y precio
                </Button>
            </b-list-group-item>
            <b-list-group-item>
                <b>{{ abonado.plaza ? 'Plaza:' : 'Asiento:' }}</b>
                <a>
                    <template v-if="abonado.tiene_asiento">
                        {{ abonado.asiento.region }}, Fila: {{ abonado.asiento.row }}, Butaca: {{ abonado.asiento.seat }}
                    </template>
                    <template v-else-if="abonado.plaza">
                        {{ getNombreButaca(abonado.plaza) }}
                    </template>
                    <template v-else>
                        Sin asiento
                    </template>
                </a>
                <Button
                    type="button" 
                    name="button"
                    id="cambiarAsiento"
                    class="ml-3" 
                    @click="$modal.show('cambiar-asiento-' + abonado.id);"
                >
                    CAMBIAR
                </Button>
            </b-list-group-item>

            <CambiarAsiento :abonado="abonado" v-on:close="cerrarModalCambiarAsiento" v-on:asientoEditado="asientoEditado"/>
            <CambiarPrecio :abonado="abonado" v-on:close="cerrarModalPrecio"/>
            
            <b-list-group-item>
                <b>Impreso: </b>{{ abonado.impresion.length > 0 ? "SI" : "NO" }}
            </b-list-group-item>
            <b-list-group-item v-if="abonado.impresion.length > 0">
                <b>Fecha ultima impresión:</b> {{ abonado.impresion[abonado.impresion.length -1].fecha_impresion }}
            </b-list-group-item>
            <b-list-group-item>
                <b>Envío a domicilio:</b> {{ abonado.envio ? 'SI' : 'NO' }}
                <div v-if="abonado.envio" class="table table-responsive mt-2">
                    <b-table striped hover :items="[abonado.envio]">
                        <template #cell(estado)="{ item }">
                            {{ item.estado ? 'ENVIADO' : 'NO ENVIADO' }}
                        </template>
                    </b-table>
                </div>
            </b-list-group-item>
            <b-list-group-item v-if="abonado.segundo_elegido">
                <b>El momento seleccionado es el:</b> {{ formatSeg(abonado.segundo_elegido) }}
            </b-list-group-item>
            <template v-if="abonado.propiedades && abonado.propiedades.length > 0">
                <b-list-group-item v-for="campo in abonado.propiedades" :key="campo.id">
                    <b>{{ campo.name }}:</b> {{ campo.value }}
                </b-list-group-item>
            </template>
        </div>
    </div>
</template>

<script>
    import CambiarAsiento from '@/views/backend/abonados/modals/CambiarAsiento';
    import CambiarPrecio from '@/views/backend/abonados/modals/CambiarPrecio';

    export default {
        props: ['abonado', 'manager'],
        methods: {
            asientoEditado() {
                this.$emit('actualizar');
            },
            cerrarModalPrecio(id, cambiado) {
                this.$modal.hide('cambiar-precio-' + id);
                if(cambiado) {
                    this.$emit('actualizar');
                }
            },
            cerrarModalCambiarAsiento(id) {
                this.$modal.hide('cambiar-asiento-' + id);
            },
            getNombreButaca(butaca) {
                const nButaca = butaca.butaca;
                const nFila = butaca.fila;
                const sector = butaca.sector_name;
                var name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += (butaca.region_name ? butaca.region_name + ' - ' : '') + `Plaza: ${butaca.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                return name
            },
            formatSeg(segundo) {
                const minutes = Math.floor(segundo / 60);
                const remainingSeconds = segundo % 60;
                return `Min: ${minutes} - Seg: ${remainingSeconds}`;
            },
        },
        components: { 
            CambiarAsiento, CambiarPrecio
        }
    }
</script>

<style scoped>
    .price-large {
        font-size: 40px !important;  
    }
</style>
